import React, { Suspense, useEffect } from "react"

import About from "../Home/components/About"
import AboutAbTest from "./components/AboutAbTest"
import { Button } from "@material-ui/core"
import Footer from "../Home/components/Footer"
import { FormattedMessage } from "react-intl"
import { GAEvent } from "../../modules/GoogleAnalytics"
import HeroSection from "./components/HeroSection"
import { Locale } from "../../locale"
import { StateProvider } from "../../state/practiceEnv"
import useLoginPopup from "../../hooks/useLoginPopup"
import { useTrack } from "@hackler/react-sdk"

const AbTestUseCase = React.lazy(() => import("./components/AbTestUseCase"))
const Dashboard = React.lazy(() => import("./components/Dashboard"))
const Practice = React.lazy(() => import("./components/Practice"))

export default function ServiceDescription() {
  const track = useTrack()
  const loginPopup = useLoginPopup()
  const { lang } = Locale.getDefault()

  useEffect(() => {
    track({ key: "homepage_ab_test_view" })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{ backgroundColor: "white" }}>
      <HeroSection />
      <AboutAbTest />
      <Suspense fallback={null}>
        {lang === "ko" && (
          <StateProvider>
            <Practice />
          </StateProvider>
        )}
        <AbTestUseCase />
        <Dashboard />
      </Suspense>
      <About
        pageName={"ab_test"}
        serviceButtonComponent={({ isMobile, className }) => (
          <Button
            color={"inherit"}
            variant={"contained"}
            fullWidth={isMobile}
            className={className}
            onClick={() => {
              GAEvent({
                category: "main-6",
                action: "click",
                label: "start abtest",
              })
              track({ key: "homepage_ab_test_about_abtest_start_click" })
              loginPopup()
            }}>
            <strong>
              <FormattedMessage id={"btn_ab_test_hero_section"} />
            </strong>
          </Button>
        )}
      />
      <Footer pageName={"ab_test"} />
    </div>
  )
}
